import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Stitch, StitchAppClient } from 'mongodb-stitch-browser-sdk';

@Component({
  selector: 'app-quiz-result',
  templateUrl: './quiz-result.component.html',
  styleUrls: ['./quiz-result.component.scss']
})
export class QuizResultComponent implements OnInit {

  @Input()  questionsList: any;
  @Input() lectureName : any;
  @Output() questionSelected = new EventEmitter<any>();
  @Output() retakeQuiz = new EventEmitter<boolean>();
  passPerentage : any = 0;
  userEmail : any;

  constructor() { }

  ngOnInit() {
    let stichApp : StitchAppClient = Stitch.defaultAppClient;
    this.userEmail = stichApp.auth.user.profile.email;
  }


  /**
   * 
   * @param question Show result for this question
   */
  showResult(question){
     // console.log(JSON.stringify(question));
      this.questionSelected.emit(question);
  }

  

  getCorrectPercentage(){
    console.log(JSON.stringify(this.questionsList));
    let totalQuestionCount = this.questionsList.length;
    let correctQuestion = 0;

    for(let i = 0;i < this.questionsList.length;i++){
      if(this.questionsList[i].answerSelected !=undefined){

        if(this.questionsList[i].attribute.answer_choice === this.questionsList[i].answerSelected.choice){ 
          correctQuestion = correctQuestion +1;
        }

      }else{
        console.log("Undefiend");
      }
    
    }

    this.passPerentage =  (correctQuestion/totalQuestionCount)*100;
    this.passPerentage = Math.round( this.passPerentage * 100 ) / 100;
    console.log("Percentage"+this.passPerentage);
  }

  /**
   * Check if ans is correct
   */
  isCorrectAns(index : any){
    //console.log(JSON.stringify(this.questionsList[index].answerSelected));
    if(this.questionsList[index].answerSelected != undefined){
      if(this.questionsList[index].answerSelected.choice === this.questionsList[index].attribute.answer_choice){
        return true;
    }else{
      return false;
    }
    }else{
      return false;
    }
    
  }




  restartQuiz(){
    this.retakeQuiz.emit(true);
  }



  ngOnChanges(){
  //  console.log(JSON.stringify(this.questionsList.answerSelected));
    this.getCorrectPercentage();
  }


}
